/**
 * @generated SignedSource<<6fc0a1947967f0ca1b62c653bdc9eecb>>
 * @relayHash dec4c3eeae49019329cdb4f44c721cf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a0902d7c7442fe6c6ecf8cedd6c2c0a0dda1653fdd59736a83c517cd15ed8e2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getVersions_jira_deployments_versionsForProject_Query$variables = {
  first: number;
  projectId: string;
};
export type getVersions_jira_deployments_versionsForProject_Query$data = {
  readonly jira: {
    readonly versionsForProject: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string;
        };
      } | null | undefined>;
    };
  };
};
export type getVersions_jira_deployments_versionsForProject_Query = {
  response: getVersions_jira_deployments_versionsForProject_Query$data;
  variables: getVersions_jira_deployments_versionsForProject_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": [
      "UNRELEASED",
      "RELEASED"
    ]
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "jiraProjectId",
    "variableName": "projectId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getVersions_jira_deployments_versionsForProject_Query",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "versionsForProject",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraVersionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraVersion",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v3/*: any*/),
                                "action": "THROW",
                                "path": "jira.versionsForProject.edges.node.name"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "jira.versionsForProject.edges.node"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.versionsForProject.edges"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.versionsForProject"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getVersions_jira_deployments_versionsForProject_Query",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8a0902d7c7442fe6c6ecf8cedd6c2c0a0dda1653fdd59736a83c517cd15ed8e2",
    "metadata": {},
    "name": "getVersions_jira_deployments_versionsForProject_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aca7bd224bde536f6132e78cabac2822";

export default node;
